(() => {
  "use strict";
  var e = {
      d: (t, i) => {
        for (var s in i)
          e.o(i, s) &&
            !e.o(t, s) &&
            Object.defineProperty(t, s, { enumerable: !0, get: i[s] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  e.r(t), e.d(t, { NewsletterForm: () => NewsletterForm });
  class NewsletterForm extends HTMLElement {
    constructor() {
      super(),
        (this.submitButton = null),
        (this.emailInput = null),
        (this.isSubmitDisabled = !0),
        (this.isEmailValid = !1),
        (this.form = null);
    }
    connectedCallback() {
      DomReadyPromise()
        .then(() => {
          (this.submitButton = this.querySelector('button[type="submit"]')),
            (this.emailInput = this.querySelector('input[type="email"]')),
            (this.form = this.querySelector("form")),
            this.emailInput &&
              this.submitButton &&
              this.form &&
              !Array.from(this.form.classList).some((e) =>
                e.includes("klaviyo")
              ) &&
              this.setupEventListeners(),
            this.setupSuccessMessageBox(),
            this.setupPolicyFancyBoxLinks(),
            this.handleScrollToView();
        })
        .catch((e) => {
          console.error(e);
        });
    }
    validateEmail(e) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
    }
    createErrorMessage(e) {
      const t = document.createElement("p");
      return (
        t.classList.add("input-error-message", "red"),
        (t.innerHTML = `\n          <span class="visually-hidden">Error</span>\n          <span>\n            <i class="fa fa-exclamation-circle" style="font-family: 'Font Awesome 5 Free' !important;" aria-hidden="true"></i>\n            ${e}\n          </span>\n        `),
        t
      );
    }
    removeErrorMessage() {
      const e = this.querySelector(".input-error-message");
      e && e.remove();
    }
    isThereInputError() {
      (this.isEmailValid = this.validateEmail(this.emailInput.value)),
        this.emailInput.parentNode.classList.toggle(
          "input-group--error",
          !this.isEmailValid
        );
    }
    handleInputBlur() {
      this.isThereInputError(),
        (this.isSubmitDisabled = !this.isEmailValid),
        this.isEmailValid && this.removeErrorMessage();
    }
    handleSubmit(e) {
      e.preventDefault(),
        e.stopPropagation(),
        this.isThereInputError(),
        this.removeErrorMessage(),
        "" !== this.emailInput.value
          ? this.isEmailValid
            ? !1 === this.isSubmitDisabled &&
              (this.form.submit(), this.submitButton.classList.add("loading"))
            : this.emailInput.parentNode.insertAdjacentElement(
                "afterend",
                this.createErrorMessage("Please enter a valid email address.")
              )
          : this.emailInput.parentNode.insertAdjacentElement(
              "afterend",
              this.createErrorMessage("Email can't be blank.")
            );
    }
    setupEventListeners() {
      this.emailInput.addEventListener("keyup", (e) => {
        e.preventDefault(),
          "Enter" === e.key ? this.handleSubmit(e) : this.handleInputBlur();
      }),
        this.emailInput.addEventListener("focus", () => {
          "" === this.emailInput.value && (this.isSubmitDisabled = !0);
        }),
        this.emailInput.addEventListener("blur", () => this.handleInputBlur()),
        this.submitButton.addEventListener("click", (e) =>
          this.handleSubmit(e)
        );
    }
    setupSuccessMessageBox() {
      const e = this.querySelector("[data-form-status]"),
        t = this.querySelector("[data-form-status] .close-toast");
      e &&
        t &&
        t.addEventListener("click", () => {
          this.querySelectorAll(".input-group.visually-hidden").forEach((e) => {
            e.classList.remove("visually-hidden");
          }),
            e.classList.add("visually-hidden"),
            window.history.replaceState(
              {},
              document.title,
              window.location.pathname
            );
        });
    }
    setupPolicyFancyBoxLinks() {
      const e = this.querySelector(".js-policy-fancybox");
      e &&
        e.addEventListener("click", async (t) => {
          t.preventDefault();
          const i = `${e.href}.json`;
          window.loadedPolicyModals = window.loadedPolicyModals || {};
          let s = window.loadedPolicyModals[i] || !1;
          if (!s) {
            let e = await fetch(i);
            if (
              ((e = 200 == e.status && (await e.json())),
              (e = e?.policy?.body || !1),
              !e)
            )
              return;
            s = window.loadedPolicyModals[i] = new ModalBox({
              content: `\n                  <div style="width:100%;max-width:700px;background:#fff;padding:var(--gutter-unit);padding-right:0;">\n                    <div style="max-height:75vh;overflow-x:hidden;overflow-y:auto;padding-right:var(--gutter-unit);color: var(--color-black);">${e}</div>\n                  </div>\n                `,
              settings: { containerCloseButton: !0 },
            });
          }
          s.open();
        });
    }
    handleScrollToView() {
      this.form &&
        window.location.hash.includes(`#${this.form.id}`) &&
        window.addEventListener("load", () => {
          this.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
  }
  customElements.get("newsletter-form") ||
    customElements.define("newsletter-form", NewsletterForm);
  var i = self;
  for (var s in t) i[s] = t[s];
  t.__esModule && Object.defineProperty(i, "__esModule", { value: !0 });
})();
